import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    planName: "",
    description: "",
    type: "DIGITAL",
    category: "SOFTWARE",
    status: "ACTIVE",
    price: "",
    billingFrequency: "",
    intervalCount: "1",
    ternureType: "REGULAR",
    sequence: "1",
    totalCycles: "0",
    currency: "",
    coverageBenefit: "",
    connectionBenefit: "",
    trial: false,
    priceTrial: "",
    sequenceTrail: 1,
    frequencyTrial: "",
    intervalCountTrial: "1",
    totalCyclesTrial: 1,
    ternureTypeTrial: "TRIAL",
}

export const createPlanStateSlice = createSlice({
    name: "createPlanStateSlice",
    initialState,
    reducers: {
        createPlanState: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
        resetCreatePlanState: () => {
            return initialState;
        }
    }
});

export const { createPlanState, resetCreatePlanState } = createPlanStateSlice.actions;
export default createPlanStateSlice.reducer;